import React from 'react';
import './LoadingIndicator.scss';

const LoadingIndicator: React.FC = () => {
  return <div className="sbl-circ-path"></div>;
};

export default LoadingIndicator;
